import p from './channel-manage.vue';

export default p;
